<app-navbar-style-one></app-navbar-style-one>

<app-homeone-banner></app-homeone-banner>

<app-footer-style-one></app-footer-style-one>